import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  WidgetFrame,
  ProgressWidget,
  ErrataWidget,
} from "../../../personal-studio-components/studio";
import {
  Table,
  TableModel,
  //from "./table";
} from "../../../personal-studio-components/table";
import { StudentService } from "../studentService";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
//from "../../Config.js";
export { Table, TableModel, TableLoader, TableLoaderView };
/** Загружает и отображает данные таблицы */
function TableLoader(props) {
  const {
    title,
    service = StudentService,
    request,
    parser = (response) => new TableModel(response),
    children,
    icon,
  } = props;
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const [response, setResponse] = useState(null);
  if (!request) throw new Error("TableLoader: request = undefined");
  request.data ??= {};
  request.data.access_token ??= access_token;
  request.data.study_contract_id ??= contractId;
  useEffect(() => {
    service.send(request, setResponse);
  }, [access_token, contractId]);
  if (!response) return <ProgressWidget title={title} />;
  if (response.errors) {
    if (response.error_type === "info") {
      return (
        <WidgetFrame title={title} icon={icon} {...props}>
          <ErrataViewInfo errata={response} />
        </WidgetFrame>
      );
    } else if (response.error_type !== "info") {
      return <ErrataWidget errata={response} />;
    }
  }
  const table = parser(response);
  return <TableLoaderView widget={props} table={table} children={children} />;
}
function TableLoaderView({ widget, table, children }) {
  //table.maxHeight = "15rem";
  //table.rows = table.rows.map(row => ({...row, onClick: () => alert("onClick")}));
  return (
    <WidgetFrame {...widget}>
      <Table {...table} />
      {children}
    </WidgetFrame>
  );
}
